export const PREVIEW_STATUS_META = {
  request_submitted: { label: "Request Submitted", pct: 5 },
  awaiting_payment: { label: "Awaiting Payment", pct: 5 },
  payment_confirmed: { label: "Payment Confirmed", pct: 10 },
  under_review: { label: "Under Review", pct: 20 },
  planning: { label: "Planning", pct: 30 },
  designing: { label: "Designing", pct: 45 },
  building_preview: { label: "Building Preview", pct: 60 },
  internal_review: { label: "Internal Review", pct: 70 },
  preview_ready: { label: "Preview Ready", pct: 80 },
  revision_requested: { label: "Revision Requested", pct: 82 },
  revision_in_progress: { label: "Revision in Progress", pct: 85 },
  approved: { label: "Approved", pct: 92 },
  blueprint_preparing: { label: "Blueprint Preparing", pct: 96 },
  completed: { label: "Completed", pct: 100 },
  cancelled: { label: "Cancelled", pct: 0 },
  refunded: { label: "Refunded", pct: 0 },
};

export const TIMELINE_STEPS = [
  "payment_confirmed",
  "under_review",
  "planning",
  "designing",
  "building_preview",
  "internal_review",
  "preview_ready",
  "approved",
  "completed",
];

export const NEXT_STEP_HINT = {
  payment_confirmed: "Our team will review your request and begin planning.",
  under_review: "We're reviewing your request and confirming scope.",
  planning: "Mapping your screens and feature set.",
  designing: "Designing your interactive preview.",
  building_preview: "Building your live preview.",
  internal_review: "Final internal quality review before we share it.",
  preview_ready: "Your live preview is ready — review it and approve or request a revision.",
  revision_requested: "We've received your revision request.",
  revision_in_progress: "Your revision is in progress.",
  approved: "Preparing your Launch Blueprint and builder prompt.",
  blueprint_preparing: "Finalizing your deliverables.",
  completed: "Your preview project is complete.",
  cancelled: "This project was cancelled.",
  refunded: "This order was refunded.",
};

export const statusLabel = (s) => (PREVIEW_STATUS_META[s] || { label: s }).label;
export const statusPct = (s, fallback = 0) => (PREVIEW_STATUS_META[s] || {}).pct ?? fallback;
